"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureGatesInitializationWithProvider = void 0;
const react_1 = require("react");
const feature_gate_js_client_1 = __importDefault(require("@atlaskit/feature-gate-js-client"));
const utils_1 = require("./utils");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */
const FeatureGatesInitializationWithProvider = ({ children, enabled = true, identifiers, customAttributes, options, initializingComponent, overrides, onReady, provider }) => {
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, react_1.useState)(!overrides &&
        (0, utils_1.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, react_1.useRef)(options);
    const providerRef = (0, react_1.useRef)(provider);
    (0, react_1.useEffect)(() => {
        optionsRef.current = options;
        providerRef.current = provider;
    }, [options, provider]);
    (0, react_1.useEffect)(() => {
        if (enabled) {
            if ((0, utils_1.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, utils_1.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 ? void 0 : onReady();
            }
            else {
                setInitialized(false);
                const initPromise = feature_gate_js_client_1.default.initializeCalled()
                    ? feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes)
                    : feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                void initPromise
                    .catch((err) => (0, utils_1.toError)(err))
                    .then((err) => {
                    setInitialized(true);
                    (0, utils_1.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 ? void 0 : onReady(err || undefined);
                });
            }
        }
        else {
            setInitialized(true);
            onReady === null || onReady === void 0 ? void 0 : onReady();
        }
        return () => (0, utils_1.clearOverrides)(overrides);
    }, [enabled, identifiers, customAttributes, overrides]);
    return (0, utils_1.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
exports.FeatureGatesInitializationWithProvider = FeatureGatesInitializationWithProvider;
exports.default = exports.FeatureGatesInitializationWithProvider;
